var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "fit-content"
    }
  }, [_vm.hasQuoteContent ? _c('div', {
    class: {
      'reference-content': true,
      reverse: _vm.message.flow === 'out',
      in: _vm.message.flow === 'in',
      isMobile: _vm.isH5,
      isPc: _vm.isPC
    },
    on: {
      "click": _vm.scrollToOriginalMessage
    }
  }, [_vm.isMessageRevoked ? _c('div', {
    class: _vm.isPC ? 'revoked-text' : ''
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("TUIChat.引用内容已撤回")) + " ")]) : _c('div', [_vm.isH5 ? _c('div', {
    staticClass: "mobile-quote-sender"
  }, [_vm._v(" " + _vm._s(_vm.quoteMessageSender) + " ")]) : _vm._e(), _c('div', {
    staticClass: "max-double-line"
  }, [_vm._v(" " + _vm._s(_vm.isPC ? _vm.quoteMessageSender + ": " + _vm.transformTextWithKeysToEmojiNames(_vm.messageQuoteText) : _vm.transformTextWithKeysToEmojiNames(_vm.messageQuoteText)) + " ")])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }